import { AlertCircle, RefreshCw, X as CloseIcon } from 'lucide-react'

interface SessionStatusBannerProps {
  error: string | null
  status?: string | null
  onReconnect?: () => void
  isReconnecting?: boolean
  onDismiss: () => void
}

export function SessionStatusBanner({
  error,
  status,
  onReconnect,
  isReconnecting = false,
  onDismiss,
}: SessionStatusBannerProps) {
  if (!error && (!status || status === 'CONNECTED' || status === 'WORKING')) {
    return null
  }

  const isDisconnected = status && status !== 'CONNECTED' && status !== 'WORKING'
  const displayTitle = isDisconnected
    ? 'Canal desconectado'
    : 'Canal de mensajería no disponible'

  const displayDescription =
    error ||
    'La sesión de mensajería no está sincronizada. Puedes reconectarla para continuar enviando mensajes.'

  return (
    <div
      role="alert"
      className="border-t border-amber-200 bg-amber-50 px-4 py-3 lg:px-6"
    >
      <div className="flex flex-wrap items-center justify-between gap-3 lg:mx-auto lg:max-w-5xl">
        <div className="flex items-start gap-3 min-w-0 flex-1">
          <div className="flex-shrink-0 rounded-full bg-amber-100 p-1.5 text-amber-700">
            <AlertCircle className="h-4 w-4 lg:h-5 lg:w-5" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-xs font-bold text-amber-900 lg:text-sm">
              {displayTitle}
            </p>
            <p className="mt-0.5 text-xs text-amber-800 leading-relaxed">
              {displayDescription}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          {onReconnect && (
            <button
              type="button"
              onClick={onReconnect}
              disabled={isReconnecting}
              className="inline-flex items-center gap-1.5 rounded-lg bg-amber-700 px-3 py-1.5 text-xs font-semibold text-white shadow-xs transition-colors hover:bg-amber-800 disabled:opacity-50 active:scale-[0.98]"
            >
              <RefreshCw
                className={`h-3.5 w-3.5 ${isReconnecting ? 'animate-spin' : ''}`}
              />
              <span>{isReconnecting ? 'Reconectando...' : 'Reconectar sesión'}</span>
            </button>
          )}

          <button
            type="button"
            onClick={onDismiss}
            aria-label="Cerrar aviso de sesión"
            className="rounded-md p-1 text-amber-600 transition-colors hover:bg-amber-100 hover:text-amber-800"
          >
            <CloseIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  )
}
